module.exports = __webpack_public_path__ + "img/icon_listmytools_privacy.d5b88ce0.svg";